import { CmsValue } from 'core/type/BootstrapConfig.types';
import { Sort } from 'gql/autogen/Sort';
import { SortMatrix } from 'gql/autogen/SortMatrix';

export enum SortField {
    RATING_DESCENDING = 'Rating_Descending',
    PRICE_ASCENDING = 'Price_Ascending',
    DEFAULT_DEFAULT = 'Default_Default',
}

export const WhitelistSortFields: string[] = [SortField.PRICE_ASCENDING.toString(), SortField.RATING_DESCENDING.toString()];

type TranslatedSortTitles = {
    [key in SortField]: string;
};

export const getTranslatedSortTitles = (cms: CmsValue): TranslatedSortTitles => ({
    [SortField.DEFAULT_DEFAULT]: cms[146552],
    [SortField.PRICE_ASCENDING]: cms[146553],
    [SortField.RATING_DESCENDING]: cms[149797],
});

export interface SortCardProps {
    cms: CmsValue;
    currentSort?: Sort;
    sortMatrix: SortMatrix;
    onChangeHandler: (sort: Sort, index: number) => void;
    visible?: boolean;
}
